export default __webpack_public_path__ + "static/media/placeholder_square_white.6335eaa7.svg";